import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldTypes } from 'projects/shared/src/models/global/FieldTypes';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { SubmitReasonComponent } from 'projects/admin/src/app/shared/components/submit-reason/submit-reason.component';
import { MatDialog } from '@angular/material/dialog';
import { TaskDetails } from 'projects/admin/src/app/features/product-evaluation-tasks/models/TaskDetails';
import { Action, AvailableActions } from '../../../models/product-evaluation-tasks/AvailableActions';
import { TaskActionData } from '../../../models/product-evaluation-tasks/TaskActionData';
import { ProductEvaluationTaskService } from '../../../services/product-evaluation-task.service';
import { ProductEvaluationTaskStatusEnum } from '../../../models/product-evaluation-tasks/enums/ProductEvaluationTaskStatusEnum';

@Component({
  selector: 'app-product-evaluation-task-actions',
  standalone: false,
  templateUrl: './product-evaluation-task-actions.component.html',
})
export class ProductEvaluationTaskActionsComponent implements OnInit {
  @Input({ required: true }) record: TaskDetails = new TaskDetails();
  availableActions: AvailableActions = new AvailableActions();
  taskStatus = ProductEvaluationTaskStatusEnum;
  loading = false

  constructor(
    public dialog: MatDialog,
    private swalService: SwalService,
    private translate: TranslateService,
    private service: ProductEvaluationTaskService
  ) { }

  ngOnInit() {
    this.getAvailableActions();
  }

  getAvailableActions() {
    this.service.getAvailableActions(this.record.taskId).subscribe((data) => {
      this.availableActions = data as AvailableActions;
    }, (error: any) => {

    })
  }

  handleClick(action: Action) {
    switch (action.apiName) {
      case 'ChangeTaskStatus':
        this.ChangeTaskStatus(action);
        break;
      default:
        let data = {
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          actionId: action.actionId,
          reason: ""
        }
        //  this.ChangeTaskStatus(data)
        break;
    }
  }

  ChangeTaskStatus(action: Action) {
    let data = {} as TaskActionData;
    switch (action.nextStatus) {
      case ProductEvaluationTaskStatusEnum.Modifications_Requested_From_First_Review:
      case ProductEvaluationTaskStatusEnum.Modifications_Requested_From_Final_Review:
      case ProductEvaluationTaskStatusEnum.Final_Report_Rejected:
        this.requestEdit(action);
        break;
      default:
        data = {
          actionId: action.actionId,
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          reason: ""
        };
        let title = this.translate.instant('swalMsg.Success');
        if (action.nextStatus === ProductEvaluationTaskStatusEnum.Waiting_First_Review) {
          title = this.translate.instant('productEvaluationTasks.productEvaluationResultsSentForReviewSuccessfully');
        } else if (action.nextStatus === ProductEvaluationTaskStatusEnum.Waiting_Final_Review) {
          title = this.translate.instant('swalMsg.evaluationResultsSentSuccessfully');
        } else if (action.nextStatus === ProductEvaluationTaskStatusEnum.Waiting_Final_Approval) {
          title = this.translate.instant('swalMsg.evaluationResultsPreliminarilyApproved');
        } else if (action.nextStatus === ProductEvaluationTaskStatusEnum.Final_Report_Approved) {
          title = this.translate.instant('swalMsg.evaluationResultsFinallyApproved');
        }
        this.confirmationAction(data, title);
        break;
    }
  }

  requestEdit(action: Action) {
    const rejectRequest = action.nextStatus === ProductEvaluationTaskStatusEnum.Final_Report_Rejected;
    const dataRecord = {
      title: this.translate.instant('monitoringTasks.' + (rejectRequest ? 'rejectRequest' : 'modificationRequest')),
      btnSubmitTitle: this.translate.instant('general.confirm'),
      showClose: true,
      service: this.service,
      serviceTarget: 'changeTaskStatus',
      hideSwalMessageSuccess: true,
      record: {
        actionId: action.actionId,
        taskId: this.record.taskId,
        nextStatus: action.nextStatus
      },
      fields: [
        {
          id: 'reason',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: rejectRequest ? this.translate.instant('monitoringTasks.rejectionReason') : this.translate.instant('rights.editRequestReason'),
          value: null,
          isMandatory: true,
          fieldLength: 1000,
          minLength: 3
        }
      ],
    };
    let title = this.translate.instant('swalMsg.evaluationModificationRequested');
    if (rejectRequest) {
      title = this.translate.instant('monitoringTasks.finalResultsRejectedSuccessfully');
    }
    this.openForm(dataRecord, title);
  }

  openForm(dataRecord: any, title: string, message = '') {
    const dialogRef = this.dialog.open(SubmitReasonComponent, {
      width: '540px',
      data: dataRecord,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.service.refreshDetails.next(true);
        this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
      }
    });
  }

  confirmationAction(data: TaskActionData, title: string = this.translate.instant('swalMsg.Success'), message = '') {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousure')).then((result) => {
      if (result.value) {
        this.loading = true;
        // const formData = new FormData();
        // formData.append('data', JSON.stringify(data));
        this.service.changeTaskStatus(data).subscribe(
          (res: any) => {
            this.loading = false;
            this.service.refreshDetails.next(true);
            this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
          },
          (err: any) => {
            this.loading = false;
            this.handleErrors(err.detail);
          }
        );
      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }
}
